module.exports = __webpack_public_path__ + "static/fonts/roboto-v20-latin-300-bda729dbf749cbb9a8e480fa2deec2e9.eot";